<template>
  <div class="contents">
    <div class="header">
      <div class="tab">
        <span
          v-for="(item, $index) in statusOptions"
          :key="$index"
          v-permissson="`${item.permissson}`"
          :class="['tabItem', { active: activeName === item.value }]"
          @click="handleClick(item.value)"
        >{{
          item.value === 10000
            ? `${item.label}(${tabTotal})`
            : `${item.label}(${
                  tabNumer?.find((a) => a.type === +item.value)?.qty || 0
            })`
        }}</span
        >
      </div>
      <div class="opt">
        <div class="download" @click="download">导出</div>
        <div class="search">
          <el-popover
            ref="popover"
            placement="top"
            class="searchPop"
            title="批量搜索"
            trigger="click"
            width="378"
          >
            <div class="close" @click="closeSearchPanel">
              <i class="el-icon-close"></i>
            </div>
            <base-muti-input
              ref="baseMutiInput"
              v-model="referenceNumber"
              :default="referenceNumber"
            ></base-muti-input>
            <div style="text-align: right; margin: 16px 0 0">
              <el-button size="small" @click="handleEmpty">清空</el-button>
              <div class="sure" @mousedown="handleConfirm">确定</div>
            </div>
          </el-popover>
          <el-input
            :value="searchVal"
            placeholder="请输入提单号搜索"
            class="input-search"
            @focus="handleFocus"
          ></el-input>
          <div class="btn-search" @click="handleConfirm">
            <i class="el-icon-search"></i>
          </div>
        </div>
        <div
          v-if="activeName === 0"
          class="btn"
          style="border-radius: 2px 0px 0px 2px"
          :class="{ 'btn-active': !notUpdateFlag }"
          @click="updateChange(false)"
        >
          已更新
        </div>
        <div
          v-if="activeName === 0"
          class="btn"
          style="border-radius: 0px 2px 2px 0px"
          :class="{ 'btn-active': notUpdateFlag }"
          @click="updateChange(true)"
        >
          未更新
        </div>
        <div v-if="filterList.date" class="checkDate flex_c_c">
          查询时间：{{ filterList.date[0] + "~" + filterList.date[1] }}
        </div>
        <div class="filter">
          <base-filter
            ref="BaseFilter"
            :width="466"
            :isActive="isActive"
            @sendFilter="sendFilter"
            @reset="reset"
          >
            <div class="filter">
              <SelectFilter
                ref="selectFilter"
                :filterListJson="filterListJson"
                :filterListId="filterListId"
                :companyDrapdown="companyDrapdown"
                @ok="ok1"
              ></SelectFilter>
            </div>
          </base-filter>
        </div>
      </div>
    </div>
    <div v-loading="loading" class="data">
      <BaseTable
        v-if="height"
        :height="height"
        :tableData="{
          ...tableData,
          fileds,
          columns,
        }"
        :pageIndex="pager.pageIndex"
        :pageSize="pager.pageSize"
        :isPager="true"
        :isEmptyBorder="true"
        @handlePageChange="handlePageChange"
        @sortChange="sortChange"
        @dblclick="dblclick"
      >
        <template slot="holdDate" slot-scope="row">
          <span v-if="isToday(row.scope.createdOn) && row.scope.createdName != 'CBP'" class="tips">NEW</span>
          {{
            row.scope.holdDate?.slice(0, row.scope.holdDate?.length - 3)
          }} </template
          >"
        <template slot="createdOn" slot-scope="row">
          {{ row.scope.createdOn }}
          <span
            v-if="
              row.scope.dischargeHarbor &&
                row.scope.originHarborName !== row.scope.dischargeHarbor
            "
            class="tips"
          >
            海铁联运
          </span>
        </template>
        <template slot="companyName" slot-scope="row">
          <template v-if="activeName === 10000 || activeName === 3">
            {{ row.scope.companyName }}
          </template>
          <template v-else>
            <span
              class="top"
              :style="{
                'background-color': row.scope.bgColor,
                'padding-left': row.scope.notUpdateFlag ? '0px' : '10px',
              }"
            >
              <img
                v-if="row.scope.notUpdateFlag"
                src="@/assets/images/bill/waitUpdate.png"
              />
              {{ row.scope.bgLabel }}
            </span>
            <img
              v-if="activeName !== 10000 && activeName !== 3"
              class="editColor"
              src="@/assets/images/bill/editColor.png"
              @click="editColor(row.scope)"
            />
            {{ row.scope.companyName }}
          </template>
        </template>
        <template slot="status" slot-scope="row">
          <span class="status" :class="status(row.scope.status)">{{
            row.scope.status | formatStatus
          }}</span>
        </template>
        <template slot="lastEventDescription" slot-scope="row">
          <p style="text-align: left">
            <span class="pickUpType pickUpType0">更新人</span
            >{{ row.scope.lastEventUserName }}
          </p>
          <p style="text-align: left">
            <span class="pickUpType pickUpType1">更新时间</span
            >{{ row.scope.lastEventDate }}
          </p>
          <p
            style="text-align: left;max-width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
            <span class="pickUpType pickUpType2">内容</span
            ><span v-html="row.scope.lastEventDescription"></span>
          </p>
        </template>
        <template slot="destroyQty" slot-scope="row">
          <p style="text-align: left">
            <span class="pickUpType pickUpType0">放行</span
            >{{ row.scope.releaseQty }}
          </p>
          <p style="text-align: left">
            <span class="pickUpType pickUpType1">扣件</span
            >{{ row.scope.holdQty }}
          </p>
          <p style="text-align: left">
            <span class="pickUpType pickUpType2">销毁</span
            >{{ row.scope.destroyQty }}
          </p>
          <p style="text-align: left">
            <span class="pickUpType pickUpType3">没收</span
            >{{ row.scope.confiscateQty }}
          </p>
        </template>
        <template slot="holdInfo" slot-scope="row">
          <div v-if="row.scope.holdInfo.length > 0" class="checkInfo">
            <div>
              <p style="text-align: left">
                <span class="pickUpType pickUpType1">查验日期</span
                >{{ row.scope.holdInfo | formatEearyDate }}
              </p>
              <p
                style="text-align: left;max-width: 100%;">
                <span class="pickUpType pickUpType2">查验类型</span
                >{{ row.scope.holdInfo | formatterInfo }}
              </p>
              <p style="text-align: left">
                <span class="pickUpType pickUpType3">查验原因</span
                >{{ row.scope.holdInfo[0].holdReason }}
              </p>
            </div>
            <div class="detail">
              <el-popover placement="bottom-end" width="560" trigger="click">
                <div class="detail-table">
                  <BaseTable
                    :height="240"
                    :tableData="{
                      ...tableDeatil,
                      columns: row.scope.holdInfo,
                    }"
                    :isPager="false"
                  >
                    <template slot="holdReason" slot-scope="detailRow">
                      <el-input
                        v-model="detailRow.scope.holdReason"
                        @blur="blur(detailRow, row.scope.holdInfo)"
                      />
                    </template>
                  </BaseTable>
                </div>
                <img slot="reference" src="@/assets/images/bill/detail.png" />
              </el-popover>
            </div>
          </div>
        </template>
        <template slot="inspectionSiteName" slot-scope="row">
          <div class="checkInfo">
            <div>
              <p style="text-align: left">
                <span class="pickUpType pickUpType1">查验场</span
                >{{ row.scope.inspectionSiteName }}
                <img
                  v-if="row.scope.inspectionSiteName"
                  class="link"
                  src="@/assets/images/bill/link.png"
                  @click="link(row.scope)"
                />
              </p>
              <p style="text-align: left">
                <span class="pickUpType pickUpType2">进查验场时间</span
                >{{ row.scope.inspectionInTime?.split(" ")[0] }}
              </p>
              <p style="text-align: left">
                <span class="pickUpType pickUpType3">出查验场时间</span
                >{{ row.scope.inspectionOutTime?.split(" ")[0] }}
              </p>
            </div>
            <div class="detail" @click="updateCheckBoard(row.scope)">
              <img src="@/assets/images/bill/editCheck.png" />
            </div>
          </div>
        </template>
        <template slot="importerName" slot-scope="row">
          <span
          ><span v-if="row.scope.isOwerCompany" class="importerName">{{
             row.scope.isOwerCompany
           }}</span>
            {{ row.scope.importerName }}</span
          >
        </template>
        <template slot="holdResult" slot-scope="row">
          {{ row.scope.holdResult }}
          <div class="detail" @click="updateHoldReason(row.scope)">
            <img src="@/assets/images/bill/editCheck.png" />
          </div>
        </template>
        <template slot="harborName" slot-scope="row">
          <p style="text-align: left">
            <span class="pickUpType pickUpType0">始发港/机场</span
            >{{ row.scope.originHarborName }}
          </p>
          <p style="text-align: left">
            <span class="pickUpType pickUpType1">卸货港</span
            >{{ row.scope.dischargeHarbor }}
          </p>
          <p style="text-align: left">
            <span class="pickUpType pickUpType2">目的港/机场</span
            >{{ row.scope.destinationHarborName }}
          </p>
          <p style="text-align: left">
            <span class="pickUpType pickUpType3">船名/航次</span
            >{{ row.scope.vesselName }}/{{ row.scope.voyageNo }}
          </p>
        </template>
        <template slot="ETDATD" slot-scope="row">
          <p style="text-align: left">
            <span class="pickUpType pickUpType0">ETD</span
            >{{ row.scope.etd | dateFilete }}
          </p>
          <p style="text-align: left">
            <span class="pickUpType pickUpType1">ATD</span
            >{{ row.scope.atd | dateFilete }}
          </p>
        </template>
        <template slot="ETAATA" slot-scope="row">
          <p style="text-align: left">
            <span class="pickUpType pickUpType0">ETA</span
            >{{ row.scope.eta | dateTimeFilter }}
          </p>
          <p style="text-align: left">
            <span class="pickUpType pickUpType1">ATA</span
            >{{ row.scope.ata | dateTimeFilter }}
          </p>
        </template>
        <template slot="opt" slot-scope="row">
          <el-popover
            :ref="`popover${row.scope.id}`"
            popper-class="pop-table-opt"
            width="114"
            trigger="hover"
          >
            <div class="table-opt">
              <div v-if="activeName === 0">
                <el-button
                  v-permissson="'editStatus'"
                  class="opt-item"
                  @click="modifyStatus(row.scope)"
                >更改状态</el-button
                >
                <el-button
                  v-permissson="'billDetail'"
                  class="opt-item"
                  @click="gotoBill(row.scope)"
                >提单详情</el-button
                >
              </div>
              <div v-if="activeName === 1">
                <el-button
                  v-permissson="'editStatus'"
                  class="opt-item"
                  @click="modifyStatus(row.scope)"
                >更改状态</el-button
                >
              </div>
              <div v-if="activeName === 2">
                <el-button
                  v-permissson="'editStatus'"
                  class="opt-item"
                  @click="modifyStatus(row.scope)"
                >更改状态</el-button
                >
              </div>
              <div v-if="activeName === 3">
                <el-button
                  v-permissson="'upload_file'"
                  class="opt-item"
                  @click="uploadFile(row.scope)"
                >上传费用凭证</el-button
                >
                <el-button
                  v-permissson="'billDetail'"
                  class="opt-item"
                  @click="gotoBill(row.scope)"
                >提单详情</el-button
                >
              </div>
            </div>
            <img
              slot="reference"
              style="margin-left: -14px"
              src="@/assets/images/table/opt.png"
            />
          </el-popover>
        </template>
        <!-- <template v-if="activeName === 0">
            <el-button
              v-permissson="'editStatus_b'"
              type="text"
              @click="modifyStatus(row.scope)"
            >更改状态</el-button
            >
            <br />
            <el-button
              v-permissson="'billDetail_b'"
              type="text"
              @click="gotoBill(row.scope)"
            >提单详情</el-button
            >
          </template>
          <template v-if="activeName === 1">
            <el-button
              v-permissson="'editStatus_c'"
              type="text"
              @click="modifyStatus(row.scope)"
            >更改状态</el-button
            >
          </template>
          <template v-if="activeName === 2">
            <el-button
              v-permissson="'editStatus_d'"
              type="text"
              @click="modifyStatus(row.scope)"
            >更改状态</el-button
            >
          </template>
          <template v-if="activeName === 3">
            <el-button
              v-permissson="'upload_file'"
              type="text"
              @click="uploadFile(row.scope)"
            >上传费用凭证</el-button
            >
            <br />
            <el-button
              v-permissson="'billDetail_e'"
              type="text"
              @click="gotoBill(row.scope)"
            >提单详情</el-button
            >
          </template> -->
      </BaseTable>
    </div>
    <UpdateCheckBoardDialog
      :rowData="rowData"
      :dialogVisible="dialogVisible"
      @ok="ok"
      @cancel="dialogVisible = false"
    ></UpdateCheckBoardDialog>
    <UpdateCheckBoardStatusDialog
      :rowData="rowData"
      :dialogVisible="dialogVisible1"
      @ok="ok"
      @cancel="dialogVisible1 = false"
    ></UpdateCheckBoardStatusDialog>
    <UpdateCheckBoardColorDialog
      :rowData="rowData"
      :dialogVisible="dialogVisible2"
      @ok="ok"
      @cancel="dialogVisible2 = false"
    ></UpdateCheckBoardColorDialog>
    <UploadFeeFileDialog
      v-if="dialogVisible3"
      :rowData="rowData"
      :dialogVisible="dialogVisible3"
      @ok="ok"
      @cancel="dialogVisible3 = false"
    ></UploadFeeFileDialog>
    <follow-up-records-drawer
      :drawer="drawer"
      :rowData="{
        ...rowData,
        id: rowData.mblId,
        status: 1,
      }"
      :showFinance="false"
      :bill-type="2"
      @close="drawer = false"
    ></follow-up-records-drawer>
    <DetailDrawer
      :drawer="drawer2"
      :billType="billType"
      :rowData="{
        ...rowData,
        id: rowData.mblId,
      }"
      @close="drawer2 = false"
    ></DetailDrawer>
  </div>
</template>

<script>
import { permissions, derive } from '@/utils/common'
const BaseFilter = () => import('@/components/filter/BaseFilter')
const BaseTable = () => import('@/components/table/BaseTable')
const SelectFilter = () => import('@/components/filter/SelectFilter')
const BaseMutiInput = () => import('@/components/base/BaseMutiInput')
import UploadFeeFileDialog from './components/UploadFeeFileDialog'
import UpdateCheckBoardColorDialog from './components/UpdateCheckBoardColorDialog'
import UpdateCheckBoardStatusDialog from './components/UpdateCheckBoardStatusDialog'
import UpdateCheckBoardDialog from './components/UpdateCheckBoardDialog'
import DetailDrawer from './components/DetailDrawer.vue'
const FollowUpRecordsDrawer = () =>
  import('@/components/drawer/FollowUpRecordsDrawer')
import {
  mblHoldRecordPages,
  mblHoldRecordSetHoldInfo,
  updateHoldResult
} from '@/api/bill'
import { getSysTableUser } from '@/api/system'
import config from '@/utils/config'
import { mapGetters } from 'vuex'
import { myMixins } from '@/mixins'
import dayjs from 'dayjs'
// import { getRouteByCode } from '@/utils/common'
export default {
  name: 'CheckList',
  components: {
    BaseFilter,
    BaseTable,
    SelectFilter,
    UpdateCheckBoardDialog,
    UpdateCheckBoardStatusDialog,
    UpdateCheckBoardColorDialog,
    UploadFeeFileDialog,
    FollowUpRecordsDrawer,
    DetailDrawer,
    BaseMutiInput
  },
  filters: {
    dateFilete: function(date) {
      if (date) {
        const newDate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(date)
        return newDate[0]
      } else {
        return ''
      }
    },
    formatStatus: function(value) {
      if (value || value === 0) {
        const item = config.checkListStatusOptions.find(
          (a) => parseInt(a.value, 10) === value
        )
        return item.label
      } else {
        return ''
      }
    },
    formatDate(date) {
      return date ? date.slice(0, date.length - 3) : ''
    },
    dateTimeFilter(time) {
      if (!time) return ''
      return time.split(' ')[0]
    },
    formatterInfo(info) {
      if (!info || info.length === 0) return ''
      return info
        .map((item) => {
          return `${item.holdCode}-${item.holdType}`
        })
        .join(',')
    },
    formatterReason(info) {
      if (!info || info.length === 0) return ''
      return info
        .map((item) => {
          return item.holdReason
        })
        .join(',')
    },
    formatEearyDate(item) {
      const data = [...item]
      if (data && data.length > 0) {
        data.sort((a, b) =>
          dayjs(a.holdDate).isBefore(dayjs(b.holdDate)) ? -1 : 1
        )
        return data[0].holdDate
      } else {
        return ''
      }
    }
  },
  mixins: [myMixins],
  data() {
    return {
      config,
      height: 0,
      activeName: 10000,
      pager: {
        pageIndex: 1,
        pageSize: 20
      },
      loading: false,
      filterList: {},
      filterListJson: [],
      tableData: {
        fileds: [],
        columns: [],
        total: 0
      },
      tableDeatil: {
        fileds: [
          {
            filed: 'holdDate',
            label: '查验日期',
            width: '150'
          },
          {
            filed: 'holdType',
            label: '查验类型',
            width: '100px'
          },
          {
            filed: 'holdReason',
            label: '查验原因(双击修改)',
            width: '',
            isCustom: true
          },
          {
            filed: 'holdCode',
            label: '查验代码',
            width: '100px'
          }
        ],
        columns: [],
        total: 0
      },
      isActive: false,
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      drawer: false,
      drawer2: false,
      billType: 0,
      userOptions: [],
      tabNumer: [],
      tabTotal: 0,
      useLogId: '0',
      statusOptions: config.checkListStatusOptions,
      editData: {},
      tableResData: {
        columns: [],
        total: 0
      },
      filterListId: '',
      rowData: {},
      notUpdateFlag: true,
      referenceNumber: '',
      searchVal: '',
      sortable: {}
    }
  },
  computed: {
    ...mapGetters([
      'addressDropOption',
      'companyDrapdown',
      'addressBookOptions'
    ]),
    addressDropCodeOption() {
      return (
        this.addressDropOption &&
        this.addressDropOption.map((item) => {
          return {
            value: item.code,
            label: item.label
          }
        })
      )
    },
    printPermissson() {
      return function(v) {
        const perNumber = [1, 2, 3]
        if (perNumber.includes(v)) {
          return true
        } else {
          return false
        }
      }
    },
    fileds() {
      const arr = [
        {
          filed: 'holdDate',
          label: '查验日期',
          width: '150',
          isSort: true,
          isCustom: true
          // formatter: (row) =>
          //   row.holdDate
          //     ? row.holdDate.slice(0, row.holdDate.length - 3)
          //     : ''
        },
        {
          filed: 'createdOn',
          label: '创建日期',
          width: '150',
          isSort: true,
          // formatter: (row) =>
          //   row.createdOn
          //     ? row.createdOn.slice(0, row.createdOn.length - 3)
          //     : '',
          isCustom: true
        },
        {
          filed: 'companyName',
          label: '客户',
          width: '180px',
          isCustom: true
        },
        {
          filed: 'mblNo',
          label: '主提单号',
          width: '200',
          isCopy: true,
          align: 'left'
        },
        {
          filed: 'blNo',
          label: '分单号',
          width: '200',
          isCopy: true,
          align: 'left'
        },
        {
          filed: 'containerNo',
          label: '柜号',
          width: '200',
          isCopy: true,
          align: 'left'
        },
        {
          filed: 'status',
          label: '状态',
          width: '120px',
          isCustom: true
        },
        {
          filed: 'lastEventDescription',
          label: '最新跟进记录(双击备注)',
          width: '240px',
          isCustom: true
        },
        {
          filed: 'holdInfo',
          label: '查验信息',
          width: '300px',
          isCustom: true
        },
        {
          filed: 'holdResult',
          label: '查验结果',
          width: '240px',
          isCustom: true
        },
        {
          filed: 'inspectionSiteName',
          label: '查验场信息',
          width: '280px',
          isCustom: true
        },
        // {
        //   filed: 'eta',
        //   label: 'ETA',
        //   width: '150',
        //   formatter: (row) =>
        //     row.eta ? row.eta.split(' ')[0] : ''
        // },
        {
          filed: 'harborName',
          label: '港口信息',
          width: '310px',
          isCustom: true
        },
        {
          filed: 'ETDATD',
          label: '开船日期',
          width: '190px',
          isCustom: true
        },
        {
          filed: 'dischargeHarborDate',
          label: '到卸货港日期',
          width: '120px',
          formatter: (row) => {
            if (!row.dischargeHarborDate) return ''
            return row.dischargeHarborDate.split(' ')[0]
          }
        },
        {
          filed: 'ETAATA',
          label: '到港日期',
          width: '200px',
          isCustom: true
        },
        {
          filed: 'importerName',
          label: '进口商',
          width: '200px',
          isCustom: true
        },
        {
          filed: 'clearenceSupplier',
          label: '清关行',
          width: '200px'
        },
        {
          filed: 'forecastAcceptUserName',
          label: '预报处理人',
          width: '100px'
          // formatter: (row) => {
          //   return row.isISA ? '是' : '否'
          // }
        }
        // {
        //   filed: 'originHarborName',
        //   label: '始发港/机场',
        //   width: '150px'
        // },
        // {
        //   filed: 'destinationHarborName',
        //   label: '目的港/机场',
        //   width: '150px'
        // },
        // {
        //   filed: 'ata',
        //   label: 'ATA',
        //   width: '150',
        //   formatter: (row) =>
        //     row.ata ? row.ata.split(' ')[0] : ''
        //   // formatter: (row) => {
        //   //   return `${row.weight ? row.weight : 0} KG`
        //   // }
        // },
        // {
        //   filed: 'atd',
        //   label: 'ATD',
        //   width: '150',
        //   formatter: (row) =>
        //     row.atd ? row.atd.split(' ')[0] : ''
        // }
      ]
      if (this.activeName !== 10000) {
        arr.unshift({
          filed: 'opt',
          label: '操作',
          width: '50px',
          isCustom: true,
          fixed: 'left'
        })
      }
      if (this.activeName === 1 || this.activeName === 2) {
        arr.splice(6, 1, {
          filed: 'destroyQty',
          label: '放行信息',
          width: '150px',
          isCustom: true
        })
      }
      return arr
    },
    columns() {
      return this.tableData.columns.map((item) => {
        const isOwerCompany = this.addressBookOptions[0]
          ?.filter((a) => +a.companyId === 0 && a.scinTypes.indexOf(4) > -1)
          .find((a) => a.companyName === item.importerName)
        return {
          ...item,
          isOwerCompany: isOwerCompany?.supplierId ? '自有' : ''
        }
      })
    }
  },
  created() {
    if (!this.companyDrapdown.length) {
      this.$store.dispatch('getCompanyDrapdown')
    }
    // this.filterList.date = getRecentMonthDate(1)
    this.getList(this.pager)
    this.getFilter()
  },
  async mounted() {
    // if (!this.addressDropOption || this.addressDropOption.length === 0) {
    //   this.$store.dispatch('getAddress')
    // }
    await this.$store.dispatch('getAddressBookOptions', {
      type: -1,
      companyId: 0
    })
    if (!this.$store.state.connect.connect.tabCode) {
      const menuList = this.$store.getters.initRouter
      const menu = permissions(this.$route.meta.code, menuList)
      const codeLits = [
        [(name) => name === 'QB', () => 10000],
        [(name) => name === 'CYZ', () => 0],
        [(name) => name === 'BFFX', () => 1],
        [(name) => name === 'QBFX', () => 2],
        [(name) => name === 'WJ', () => 3]
      ]
      this.activeName = codeLits.find((a) => a[0](menu.children[0].code))[1]()
    }
    this.height = document.querySelector('.data').offsetHeight - 43
  },
  methods: {
    updateChange(flag) {
      this.notUpdateFlag = flag
      const param = {
        pageIndex: 1,
        pageSize: this.pager.pageSize
      }
      this.pager = param
      this.selectionItem = []
      this.getList(param)
    },
    status(status) {
      const statusObj = {
        0: 'status-0',
        1: 'status-1',
        2: 'status-2',
        3: 'status-3'
      }
      return statusObj[status]
    },
    // isOwerCompany(company) {
    //   const item = this.addressBookOptions[0].find(
    //     (a) => a.companyName === company
    //   )
    //   return item?.supplierId ? '自有' : ''
    // },
    handleClick(index) {
      this.activeName = index
      const param = {
        pageIndex: 1,
        pageSize: this.pager.pageSize
      }
      this.pager = param
      this.selectionItem = []
      this.getList(param)
    },
    dblclick(row) {
      this.rowData = row
      this.drawer = true
    },
    async getFilter() {
      try {
        const res = await getSysTableUser({
          tableCode: 'MBLHoldRecord',
          type: 1
        })
        if (res.success) {
          this.filterListJson = JSON.parse(res.data.value)
          this.filterListId = res.data.id
          console.log('filterListJson', this.filterListJson)
        }
      } catch (error) {
        console.warn(error)
      }
    },
    ok1() {
      this.getFilter()
    },
    handlePageChange(pager) {
      this.pager = pager
      this.getList(pager)
    },
    sortChange(orderObj) {
      this.sortable = {
        sortField: orderObj.prop,
        sortBy: orderObj.order === 'asc' ? 0 : 1
      }
      this.getList(this.pager)
    },
    sendFilter() {
      const filterList = this.$refs.selectFilter.getData()
      if (Object.keys(filterList).length > 0) {
        this.isActive = true
      }
      this.filterList = filterList
      this.initList()
    },
    async getList(params) {
      this.loading = true
      try {
        params = {
          ...params,
          queryParam: {
            status: this.activeName !== 10000 ? this.activeName : undefined,
            ...this.sortable,
            ...this.filterList,
            notUpdateFlag:
              this.activeName === 0 ? this.notUpdateFlag : undefined,
            search: this.searchVal
            // ...this.formatFilter()
          }
        }
        const res = await mblHoldRecordPages(params)
        this.loading = false
        if (res.success) {
          this.tableData.columns = res.data.list
          this.tableData.total = res.data.total
          this.tabNumer = res.data.tabNumer
          this.tabTotal = res.data.tabTotal
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        this.loading = false
        console.error(error)
      }
    },
    reset() {
      this.$refs.selectFilter.reset()
      this.isActive = false
    },
    ok() {
      this.dialogVisible = false
      this.dialogVisible1 = false
      this.dialogVisible2 = false
      this.initList()
    },
    updateCheckBoard(row) {
      this.rowData = row
      this.dialogVisible = true
    },
    updateHoldReason(row) {
      this.$prompt('请输入查验结果', '查验结果', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: row.holdResult,
        inputValidator: function(val) {
          if (!val) {
            return '查验结果不能为空'
          }
        }
      })
        .then(({ value }) => {
          updateHoldResult({
            mblId: row.mblId,
            holdResult: value
          }).then((res) => {
            if (res.success) {
              this.$message.success('更新查验结果成功')
              this.getList(this.pager)
            } else {
              this.$message.error(res.errorMessage)
            }
          })
        })
        .catch(() => {})
    },
    modifyStatus(row) {
      this.rowData = row
      this.dialogVisible1 = true
    },
    editColor(row) {
      this.rowData = row
      this.dialogVisible2 = true
    },
    uploadFile(row) {
      this.rowData = row
      this.dialogVisible3 = true
    },
    gotoBill(row) {
      this.rowData = row
      this.drawer2 = true
      this.billType = row.containerNo ? 1 : 0
      // const menuCode = row.containerNo ? 'HYTD' : 'KYTD'
      // const path = getRouteByCode(menuCode)
      // const params = { menuCode, queryJson: JSON.stringify({ 'mblNo': row.blNo, queryParam: { 'mblNo': [row.blNo], status: '', subStatus: '' }}) }
      // this.$store.commit('SET_CONNNET', params)
      // if (path !== this.$route.fullPath) {
      //   this.$router.push(path)
      // }
    },
    initList() {
      const param = {
        pageIndex: 1,
        pageSize: 20
      }
      this.pager = param
      this.getList(param)
    },
    async blur(row, holdInfo) {
      console.log(row, holdInfo)
      try {
        const res = await mblHoldRecordSetHoldInfo(holdInfo)
        if (res.success) {
          this.$message.success('更新成功')
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    link(row) {
      window.open(row.inspectionSiteUrl, '_blank')
    },
    handleFocus() {
      this.$refs.popover.doShow()
    },
    closeSearchPanel() {
      this.handleConfirm()
    },
    handleEmpty() {
      this.referenceNumber = ''
      this.searchVal = ''
      this.$refs.baseMutiInput.reset()
      this.$refs.popover.doClose()
      this.initList()
    },
    handleConfirm() {
      // mousedown 早于 change 执行 所以延时  如果用click则 change后不执行代码
      setTimeout(() => {
        if (this.referenceNumber && this.referenceNumber !== '') {
          this.searchVal = this.referenceNumber.join(';')
        }
        this.$refs.popover.doClose()
        // todo 重置filter
        this.filterList = {}
        this.$refs.selectFilter.reset()
        const param = {
          pageIndex: 1,
          pageSize: 20
        }
        this.pager = param
        this.isActive = false
        this.getList(param)
      }, 0)
    },
    async download() {
      const params = {
        ...this.filterList,
        status: this.activeName !== 10000 ? this.activeName : undefined
      }
      this.loading = true
      await derive('MBL/exportmblHoldRecordList', 'post', params)
      this.loading = false
    },
    isToday(date) {
      const d = new Date(date).setHours(0, 0, 0, 0)
      const today = new Date().setHours(0, 0, 0, 0)
      return d === today
    },
    detailRow(row) {
      this.rowData = row
    }
  }
}
</script>

<style lang="less" scoped>
.contents {
  width: 100%;
  padding: 0 10px;
  height: 100%;
  background: #fff;
  box-sizing: border-box;
  overflow: auto;
  position: relative;
  .header {
    width: 100%;
    height: 64px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .tabItem {
    padding: 20px;
    width: 42px;
    height: 19px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    line-height: 20px;
    cursor: pointer;
  }
  .active {
    color: rgb(18, 88, 188);
  }
  .btn {
    width: 60px;
    height: 30px;
    background: rgb(18, 88, 188);
    background: #eeeeee;
    opacity: 1;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    line-height: 30px;
    cursor: pointer;
  }
  .btn-active {
    color: #ffffff;
    background: rgb(18, 88, 188);
  }
  .data {
    width: 100%;
    height: calc(100% - 64px);
    & .fTable {
      border-top: 1px solid #ebeef5;
      box-sizing: border-box;
    }
    .pickUpType {
      display: inline-block;
      padding: 4px 12px;
      width: auto;
      height: 16px;
      font-size: 12px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      line-height: 16px;
    }
    .pickUpType0 {
      color: rgb(18, 88, 188);
      background: rgba(35, 149, 243, 0.1);
    }
    .pickUpType1 {
      color: rgb(157, 103, 254);
      background: rgba(157, 103, 254, 0.1);
    }
    .pickUpType2 {
      color: #feaa4f;
      background: rgba(254, 170, 79, 0.1);
    }
    .pickUpType3 {
      color: rgb(53, 186, 131);
      background: rgb(224, 249, 238);
    }
    .pickUpType4 {
      color: rgb(157, 103, 254);
      background: rgb(233, 221, 255);
    }
  }
  .tips {
    position: absolute;
    top: 0;
    left: 0;
    width: auto;
    padding: 0 8px;
    display: inline-block;
    height: 20px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 12px;
    color: #ff7444;
    background-color: rgba(255, 116, 68, 0.1);
    line-height: 20px;
  }
  .top {
    position: absolute;
    padding: 0 10px;
    display: inline-block;
    top: 0;
    left: 0;
    height: 20px;
    font-size: 12px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 20px;
  }
  .editColor {
    position: absolute;
    left: 5px;
    cursor: pointer;
  }
  .status {
    width: 60px;
    display: inline-block;
    height: 26px;
    border-radius: 4px 4px 4px 4px;
    font-size: 12px;
    font-weight: 400;
    color: #35ba83;
    line-height: 26px;
  }
  .status-0 {
    background: rgba(35, 149, 243, 0.1);
    color: rgb(18, 88, 188);
  }
  .status-1 {
    background: rgba(255, 116, 68, 0.1);
    color: rgba(255, 116, 68, 1);
  }
  .status-2 {
    background: rgba(53, 186, 131, 0.1);
    color: rgba(53, 186, 131, 1);
  }
  .status-3 {
    background: rgba(157, 103, 254, 0.1);
    color: rgba(157, 103, 254, 1);
  }
  .panel {
    width: 100%;
    text-align: left;
    .label {
      width: 60px;
      height: 20px;
      background: rgba(255, 116, 68, 0.1);
      border-radius: 2px 2px 2px 2px;
      font-size: 12px;
      font-weight: 400;
      color: #ff7444;
      line-height: 20px;
      text-align: center;
      display: inline-block;
    }
    .value {
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      line-height: 20px;
      margin-left: 5px;
      max-width: 126px;
      display: inline-block;
    }
    .link {
      vertical-align: -3px;
      cursor: pointer;
    }
  }
  .checkInfo {
    display: flex;
    .detail {
      margin-left: 20px;
      display: flex;
      align-items: center;
      img {
        cursor: pointer;
      }
    }
  }
  .importerName {
    display: inline-block;
    width: 30px;
    height: 20px;
    background: rgb(18, 88, 188);
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    font-size: 12px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 20px;
    text-align: center;
  }
  .opt {
    display: flex;
    .download {
      width: 82px;
      height: 30px;
      background: rgb(18, 88, 188);
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      display: flex;
      justify-content: center;
      cursor: pointer;
      align-items: center;
      box-sizing: border-box;
      border-radius: 4px;
      margin-right: 10px;
    }
    .btn {
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      cursor: pointer;
      box-sizing: border-box;
    }
    .search {
      position: relative;
      display: flex;
      width: 240px;
      margin-right: 5px;
      .searchPop {
        /deep/ .el-popover {
          z-index: 9999;
          right: 0;
        }
        .close {
          position: absolute;
          top: 6px;
          right: 10px;
          cursor: pointer;
          font-size: 20px;
        }
      }
      .input-search {
        width: 206px;
        height: 30px !important;
        /deep/ .el-input__inner {
          height: 30px;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }
      }
      .btn-search {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 33px;
        height: 30px;
        border: 1px solid #dbe4f2;
        border-left: 0;
        border-radius: 0 4px 4px 0;
        cursor: pointer;
        box-sizing: border-box;
      }
    }
    .filter {
      height: 30px;
      margin-left: 8px;
    }
  }
}
.detail-table {
  width: 520px;
  height: 240px;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  margin: 8px auto;
  &:deep(.el-input__inner) {
    border: 0;
  }
}
.sure {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
  text-align: center;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  transition: 0.1s;
  font-weight: 500;
  padding: 8px 15px;
  font-size: 14px;
  border-radius: 4px;
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  margin-left: 10px;
}
</style>
